module.exports = __webpack_public_path__ + "static/img/wechatPay.8a9b140.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/register/wechatPay.jpg
// module id = RdW1
// module chunks = 1